import { FetchQueryOptions } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'
import referralService from '@/lib/services/referralService'
import {
  ReferralDetailsTab,
  SelectServiceFormValues,
} from '@/pages/referClient/types'
import { ReferralSetupDataItem } from '@/types/responses/referrals'

export const REFERRAL_DETAILS_TAB: Record<
  ReferralDetailsTab,
  ReferralDetailsTab
> = {
  selectFirm: 'selectFirm',
  selectService: 'selectService',
}

export const STEP_CONTROLS_DOM_ID = 'StepControls'

export const FETCH_REFERRAL_SETUP_DATA_QUERY_OPTIONS: FetchQueryOptions<ReferralSetupDataItem> =
  {
    queryKey: QUERY_KEYS.referralSetupData(),
    queryFn: () => referralService.getReferralSetupData(),
    staleTime: 5000,
  }

export const SELECT_SERVICES_TITLE = 'What does your client need help with?'

export const SELECT_SERVICE_FORM_FIELDS: Record<
  keyof SelectServiceFormValues,
  keyof SelectServiceFormValues
> = {
  isExpectingCommission: 'isExpectingCommission',
  expectedCommissionAmount: 'expectedCommissionAmount',
  knowsCommissionAmount: 'knowsCommissionAmount',
  serviceAreaIds: 'serviceAreaIds',
  referralJustification: 'referralJustification',
}
